<template>
  <div>
    <DropDownBox
      prefix="Тема"
      title="Тема оформления"
      placeholder="не выбрано"
      :showSeparator="true"
      :options="$store.state.themes"
      :show-radio="$store.state.onMobile"
      :hide-scrollbar="$store.state.onMobile"
      field-key="key"
      field-value="value"
      @option-focus="previewTheme"
      @blur="undoCurrentTheme"
      @focus="currentTheme=$store.state.systemSetting.theme"
      v-model="$store.state.systemSetting.theme"
      @input="selectedThemeChanged"
    />
  </div>
</template>

<script>
export default {
  name: 'VisualAppearanceOptions',
  components: {
  },
  data: function () {
    return {
      currentTheme: null
    }
  },
  methods: {
    save() {
      this.$store.dispatch('saveSettings');
    },
    selectedThemeChanged(theme) {
      this.currentTheme = this.$store.state.systemSetting.theme = theme;
      this.$store.dispatch('applyTheme', 'options-style');
      this.save();
    },
    undoCurrentTheme() {
      this.$store.state.systemSetting.theme = this.currentTheme;
      this.$store.dispatch('applyTheme', 'options-style');
    },
    previewTheme(option) {
      this.$store.state.systemSetting.theme = option.key;
      this.$store.dispatch('applyTheme', 'options-style');
    },
  },
  mounted() {
    this.currentTheme = this.$store.state.systemSetting.theme;
  },
}
</script>
